import React from 'react';
import classNames from 'classnames';
import { PerfectScrollbar } from '../../../../shared/ReactPerfectScrollbar';

function GA2RFValuesTableBody({ children, className, style }) {
  return (
    <PerfectScrollbar className={classNames('rt-tbody', className)} style={style}>
      {children}
    </PerfectScrollbar>
  );
}

export default GA2RFValuesTableBody;
